<template>
  <v-card>
    <v-card-title class="justify-center" style="font-size: 1.5em;">
        Cadastrar uma nova automação
    </v-card-title>
    <v-container fluid grid-list-md>
      <v-form lazy-validation v-model="valid" ref="form">
        <v-layout row wrap>
            <v-flex xs12>
                <v-text-field
                  label="Nome da Automação"
                  counter="20"
                  maxlength="20"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  v-model="automacao.nome"
                  required
                >
                </v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-text-field
                  label="Linha da planilha onde está o cabeçalho"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  mask="##############"
                  v-model="automacao.linha_cabecalho"
                  required
                >
                </v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-text-field
                  label="Nome do cabeçalho"
                  counter="50"
                  maxlength="50"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  v-model="automacao.nota_field"
                  required
                >
                </v-text-field>
            </v-flex>
            <v-container fluid>
              <v-switch
                v-model="automacao.para_abastecimento"
                label="Para Abastecimento"
                color="primary"
              ></v-switch>
            </v-container>
            <v-flex>
                <v-textarea
                  outline
                  label="Descrição da Automação"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  counter="256"
                  maxlength="256"
                  v-model="automacao.descricao"
                  required
                >
                </v-textarea>
            </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    <v-card-actions>
        <v-btn flat color="info" @click="fechar()">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" flat color="info" @click="habilitarAutomacao">Confirmar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  data () {
    return {
      valid: false,
      automacao: {
        nome: null,
        descricao: null,
        nota_field: null,
        linha_cabecalho: 0,
        para_abastecimento: false
      }
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    fechar () {
      this.$refs.form.reset()
      this.$emit('fechar')
    },
    habilitarAutomacao () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('inserirAutomacao', this.automacao).then(() => {
          this.$emit('info', 'Automacao habilitada com sucesso')
          this.fechar()
        }).catch(() => {
          this.$emit('error', 'A automacação não pôde ser habilitada')
          this.fechar()
        })
      }
    }
  }
}
</script>
